import BirthdayDetails from "./BirthdayDetails";

export default BirthdayDetails;
